var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_9_71028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6869 11H31.5415C33.7284 11 35.4723 12.7716 35.4723 14.9308V16.7855H29.6869V11ZM29.7145 20.1072H35.4999V25.8927H29.7145V20.1072ZM29.7145 34.9723H31.5691C33.756 34.9723 35.4999 33.2007 35.4999 31.0415V29.1869H29.7145V34.9723ZM15.4308 34.9722C13.2716 34.9722 11.5 33.2283 11.5 31.0414V29.2145H17.2855V34.9722H15.4308ZM17.2855 20.1072H11.5V25.8927H17.2855V20.1072ZM11.5 16.7855V14.9308C11.5 12.7716 13.2716 11 15.4308 11H26.3927V35H20.6073V16.7855H11.5Z",
    fill: "url(#paint0_linear_9_71028)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_9_71028",
    x: 0.08461,
    y: 0.726149,
    width: 46.8307,
    height: 46.8308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.7077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.843137 0 0 0 0 0 0 0 0 0.77 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_71028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_71028",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.42462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71231
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.843137 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_9_71028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_71028",
    x1: 23.5,
    y1: 11,
    x2: 23.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipGold);
export default __webpack_public_path__ + "static/media/chip-gold.b9a1ff45ed486dc338664efbeb7d24ee.svg";
export { ForwardRef as ReactComponent };